<template>
   <a-card :bordered="false">
       <a-form layout='inline'>
           <a-form-item label="日期">
               <a-select v-model:value="search.search_date_type" style="width: 120px" ref="select" @change="handleChange">
                  <a-select-option :value="1">日</a-select-option>
                  <a-select-option :value="2">自然周</a-select-option>
                  <a-select-option :value="3">自然月</a-select-option>
                  <a-select-option :value="4">近7天</a-select-option>
                  <a-select-option :value="5">自定义时间</a-select-option>
                </a-select>
           </a-form-item>
           <a-form-item label="">
               <!-- <a-date-picker v-model:value="search.search_time" :disabledDate="disabledDate" v-if="search.search_date_type=='1'" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD'/>
               <a-week-picker v-else-if="search.search_date_type=='2'" :disabledDate="disabledDate" v-model:value="search.search_time"  @change="changeWeek" />
               <a-month-picker v-model:value="search.search_time" v-else-if="search.search_date_type=='3'"  :disabledDate="disabledDate" valueFormat='YYYY-MM' format='YYYY-MM' /> -->
                <a-date-picker v-model:value="search.search_time" :disabledDate="disabledDate" v-if="search.search_date_type=='1'" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' />
                <a-week-picker v-else-if="search.search_date_type=='2'" :disabledDate="disabledDate" @change="changeWeek" v-model:value="weekTime" />
                <a-month-picker v-model:value="search.search_time" v-else-if="search.search_date_type=='3'"  :disabledDate="disabledDate" valueFormat='YYYY-MM' format='YYYY-MM' />
               <a-range-picker v-if="search.search_date_type=='5'" v-model:value="time" :disabledDate="disabledDate" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' style="width:300px"/>
           </a-form-item>
           <a-form-item label="所属门店" class="s_po_re">
               <a-input v-model:value="search.store_name" readonly placeholder="请选择门店" style="width:220px"></a-input>
                <CloseCircleOutlined v-if="search.store_name" class="CloseCircleOutlined s_shou" @click="search.store_name='';search.store_id=''"/>
           </a-form-item>
           <a-form-item>
               <a-button type="primary" @click="showStore=true">选择</a-button>
           </a-form-item>
           <a-form-item>
               <a-button type="primary" @click="onSearch">搜索</a-button>
           </a-form-item>
        </a-form>
        <div class="m-t-20">
            <h4 class="m-b-20 fz-16">兑换概览</h4>
             <div class="s_flex_bian_c">
                 <div class="data-content-nav-item">
                     <p class="fz-14">兑换次数</p>
                     <p class="fz-20 s_font_b m-t-10">{{exchangeData.number || 0}}</p>
                 </div>
                 <div class="data-content-nav-item">
                     <p class="fz-14">兑换商品数</p>
                     <p class="fz-20 s_font_b m-t-10">{{exchangeData.exchange_num || 0}}</p>
                 </div>
                 <div class="data-content-nav-item">
                     <p class="fz-14">支付积分</p>
                     <p class="fz-20 s_font_b m-t-10">{{exchangeData.point_num || 0}}</p>
                 </div>
                 <div class="data-content-nav-item">
                     <p class="fz-14">支付金额</p>
                     <p class="fz-20 s_font_b m-t-10">{{exchangeData.pay_price || 0}}</p>
                 </div>
             </div>
        </div>
        <div class="m-t-20">
            <h4 class="m-b-20 fz-16">兑换明细</h4>
            <a-table :pagination='pagination' :loading='listLoading' bordered :columns='columns' :data-source='list' @change="changePage">
                <template v-slot:userInfo="{record}">
                     <div >
                           <a-card-meta>
                             <template #avatar>
                               <img :src="record.headimgurl" alt="" style="width:50px;height:50px">
                             </template>
                             <template #description>
                               <p class="s_omit2" style="width: 320px;">{{record.member_name || '无'}}</p>
                             </template>
                           </a-card-meta>
                     </div>
                 </template>
            </a-table>
        </div>
       <!-- 所属门店 -->
       <a-modal  :keyboard="false" centered title="选择门店" v-model:visible="showStore" :width='1200' :footer="null" destroyOnClose>
         <selectStore v-on:select="selectStore"  :hiddenHead='true' :selectList='storeList'></selectStore>
       </a-modal>
   </a-card>
</template>

<script>
import {CloseCircleOutlined} from '@ant-design/icons-vue';
import { ref,reactive,toRefs, onMounted } from 'vue'
import moment from 'moment';
import store from "@/store";
import {giftStatistics}  from '@/api/guide';
import { iscode } from '../../../../utils/app';
import { message } from 'ant-design-vue';
import { useTime } from "@/hooks/utils/useTime";
const columns = [
    {
      title: "兑换用户",
      dataIndex: "clerk_name",
      key: "clerk_name",
    },
    {
      title: "微信昵称",
      dataIndex: "member_name",
      key: "member_name",
      slots: { customRender: "userInfo" },
    },
    {
      title: "所属门店",
      dataIndex: "store_name",
      key: "store_name",
    },
    {
      title: "兑换次数",
      dataIndex: "number",
      key: "number",
    },
    {
      title: "兑换商品数",
      dataIndex: "exchange_num",
      key: "exchange_num",
    },
    {
      title: "支付积分",
      dataIndex: "point_num",
      key: "point_num",
    },
    {
      title: "支付金额",
      dataIndex: "pay_price",
      key: "pay_price",
    }
]
export default{
    components:{CloseCircleOutlined},
  setup(){
        const { dateTargets, typeToStartEnd } = useTime();
      const search = ref({
            store_name:'',
            store_id:'',
            search_date_type:1,
            search_time:'',
            start_time:'',
            end_time:'',
            page:1,
            limit:10
        })
       const state = reactive({
               info: store.state.user.info,
               disabledDate:function(current) {
                  return current && current > moment().subtract(0, 'days').endOf('day')
                },
                pagination:{ 
                 total:0,
                 current:1,
                 pageSize:10,
                 defaultPageSize:10,
                 showSizeChanger:true,
                 pageSizeOptions:['10', '20', '30', '40', '50'], 
                 showQuickJumper:true, 
                 showTotal:(total)=> `共 ${total} 条`,
               },
                listLoading:false,
                list:[],
                storeList:[],
                showStore:false,
                exchangeData:{}
         })
          const dateTime = reactive({
              dayTime: "",
              weekTime: "",
              monthTime: "",
              quarterTime: "",
              time: [],
            });
            
        const getTable = async () => {
             switch (search.value.search_date_type) {
               case 1:
                 search.value.end_time = search.value.search_time;
                 search.value.start_time = search.value.search_time;
                 break;
               case 2:
                 search.value.start_time = search.value.search_time.split(",")[0];
                 search.value.end_time = search.value.search_time.split(",")[1];
                 break;
               case 3:
                 search.value.start_time = moment(search.value.search_time)
                   .startOf("month")
                   .format("YYYY-MM-DD");
                 search.value.end_time = moment(search.value.search_time)
                   .endOf("month")
                   .format("YYYY-MM-DD");
                 break;
                 case 5:
                   search.value.search_time = dateTime.time;
                   search.value.start_time = dateTime.time[0]
                   search.value.end_time = dateTime.time[1]
             }
           };

         const methods ={
             handleChange(e){
                     search.value.search_time = "";
                     switch (e) {
                       case 1:
                         search.value.search_time = typeToStartEnd("1").start_time;
                         search.value.end_time = typeToStartEnd("1").end_time;
                         search.value.start_time = typeToStartEnd("1").start_time;
                         break;
                       case 2:
                         search.value.start_time = typeToStartEnd("7").start_time;
                         search.value.end_time = typeToStartEnd("7").end_time;
                         search.value.search_time = typeToStartEnd("7").start_time + "," + typeToStartEnd("7").end_time;
                         dateTime.weekTime = typeToStartEnd("week").end_time;
                         break;
                       case 3:
                         search.value.search_time = dateTargets("month");
                         search.value.start_time = typeToStartEnd("month").start_time;
                         search.value.end_time = typeToStartEnd("month").end_time;
                         break;
                       case 4:
                         search.value.search_time = typeToStartEnd("1").start_time;
                         search.value.end_time = typeToStartEnd("1").end_time;
                         search.value.start_time = typeToStartEnd("7").start_time;
                         break;
                     }
             },
             selectStore(e){
                console.log(e)
                search.value.store_name = e.store_name;
                search.value.store_id = e.id;
                state.storeList = [e];
                state.showStore = false
             },
            async getGiftStatistics(){
                state.listLoading = true;
                state.list = [];
                let res = await giftStatistics({...search.value}).then(res=>res.data);
                state.listLoading = false;
                if(iscode(res)){
                   state.list = res.data.list.data || [];
                   state.exchangeData = res.data.data || {};
                   state.pagination.total = res.data.list.total;
                }else{
                  message.error(res.msg)
                }
             },
             onSearch(){
               getTable()
              search.value.page = 1
              state.pagination.current =1;
               methods.getGiftStatistics()
             },
             changePage(e){
                 state.pagination.current = e.current;
                 state.pagination.pageSize = e.pageSize;
                 search.value.page = e.current;
                 search.value.limit = e.pageSize;
                 methods.getGiftStatistics()
             }
         }
           // 切换周
        const changeWeek = (weekData) => {
          if (!weekData) {
            search.value.search_time = "";
            return;
          }
          const startDate = moment(weekData).day(1).format("YYYY-MM-DD"); // 周一日期
          const endDate = moment(weekData).day(7).format("YYYY-MM-DD"); // 周日日期
          search.value.search_time = startDate + "," + endDate;
        };

         onMounted(()=>{
           methods.handleChange(1)
           methods.getGiftStatistics()
         })

        return {
            search,
            ...toRefs(state),
            ...methods,
            columns,
            changeWeek,
            ...toRefs(dateTime),
        }
    }
}
</script>
<style lang="less" scoped>
  .data-content-nav-item {
    width: 20%;
    color: #333;
    font-size: 14px;
    padding-top: 30px;
    padding-bottom: 30px;
    cursor: pointer;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(27, 66, 108, 0.28);
    border-radius: 8px;
    text-align: center;
  }
  .CloseCircleOutlined{
    position: absolute;
    top:50%;
    right:8px;
    transform: translateY(-50%);
}
</style>